<app-ariane-nav [label]="arianeLabel" [icon]="arianeIcon" [arianeList]="this.arianeList"></app-ariane-nav>
<mat-divider class="my-3"></mat-divider>
<div class="filter-container">
  <mat-form-field class="mt-20 col-xs-12 field-filtre">
    <mat-label>Filter</mat-label>
    <input matInput #filterInput [formControl]="filterGenerique" />
    @if (filterGenerique.value) {
      <button matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()" type="button">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
</div>
<div class="row">
  <div class="col flex-container end align-items-center">
    @if (isExporting) {
      <div class="export-notification">Export en cours...</div>
    }
    <div>
      <button mat-stroked-button class="bt-table-defaut mr-5" (click)="exportListePoste()"><mat-icon>download</mat-icon>Exporter</button>
    </div>
  </div>
</div>

<div class="optimzed">
  <app-data-table-optimized
    #dataTablePoste
    [displayedColumns]="demandesDisplayedColumns"
    [getData]="loadListPostes"
    [externalFilter$]="filterSubject"
    [cellStyleCss]="demandesCellStyleCss"
    [hasView]="false"
    [hasPagination]="true"
    [selectable]="false"
    [editable]="false"
    [renewable]="false"
    [deletable]="false"
    [downloadable]="false"
    [downloadablePJ]="false"
    [downloadablePJ_hidden]="false"
  >
  </app-data-table-optimized>
</div>
